import React from "react";
import MyProcesses from "~/Pages/MyDashboard/components/MyProcesses";
import Layout from "~/Layout";
import "./my-dashboard.scss";
import QuickSummary from "./components/QuickSummary/QuickSummary";
import UpcomingEvents from "./components/UpcomingEvents/UpcomingEvents";
import MyDashboardQuickActions from "./components/MyDashboardQuickActions";

import useMyDashboard from "./useMyDashboard";
import EventDetailCalender from "../MyCalendar/components/EventDetailCalender";
const MyDashboard = () => {
  const {
    allEntities,
    loading,
    eventDetail,
    handleSelectEvent,
    setShowEventList,
    showEventList,
  } = useMyDashboard();

  return (
    <Layout
      title="Dashboard"
      SideNavSection={() => (
        <>
          {showEventList ? (
            <div className="sidenav__quick__actions m-0">
              <MyDashboardQuickActions />
              <UpcomingEvents handleSelectEvent={handleSelectEvent} />
            </div>
          ) : (
            <>
              <div className="event__detail m-0">
                <EventDetailCalender
                  eventDetail={eventDetail}
                  closeEventBtn={false}
                  backBtn={true}
                  handleViewMoreEvent={() => {
                    setShowEventList(true);
                  }}
                />
              </div>
            </>
          )}
        </>
      )}
    >
      <QuickSummary allEntities={allEntities} isloading={loading} />
      <MyProcesses allEntities={allEntities} />
    </Layout>
  );
};

export default MyDashboard;
